<!--HTML-->
<template>
  <router-view/>
  <InadimplenteModal :show="showInadimplenteModal" @close="showInadimplenteModal = false" />
  <RepresentanteFab />
</template>

<!--JS-->
<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue'
import { useFCM } from '@/composables/useFCM'
import InadimplenteModal from '@/components/InadimplenteModal.vue'
import RepresentanteFab from '@/components/RepresentanteFab.vue'

const { ouvirForeground } = useFCM()

// Só escuta mensagens em foreground — permissão é pedida manualmente pelo usuário nas Configurações
onMounted(() => {
  ouvirForeground(payload => {
    const { title, body } = payload.notification || {}
    if (!title) return
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification(title, { body, icon: '/favicon.ico' })
    }
  })
})

// Modal de inadimplência — global, dispara em qualquer tela (interceptor api.js)
const showInadimplenteModal = ref(false)
function handleInadimplente() { showInadimplenteModal.value = true }

onMounted(() => window.addEventListener('aerj:inadimplente', handleInadimplente))
onBeforeUnmount(() => window.removeEventListener('aerj:inadimplente', handleInadimplente))
</script>

<!--CSS-->
<style scoped>

</style>
